import { TAG_ICON_MAP, type TagIconName } from '../components/Menu/TagIcon';
import { stripTagEmoji } from '../components/RestaurantMenu/MenuListingIcons';
import React from 'react';

interface TagStyle { icon: TagIconName | null; bg: string; color: string; border: string; }

export const TAG_STYLES: Record<string, TagStyle> = {
  'Bestseller':      { icon: 'trophy',  bg: '#FFFBEB', color: '#92400E', border: '#F59E0B' },
  "Today's Special": { icon: 'star',    bg: '#FFF7ED', color: '#C2410C', border: '#F97316' },
  'Must Try':        { icon: 'flame',   bg: '#FFF7ED', color: '#C2410C', border: '#F97316' },
  'Spicy':           { icon: 'chili',   bg: '#FFF1F2', color: '#BE123C', border: '#FB7185' },
  'Healthy':         { icon: 'leaf',    bg: '#ECFDF5', color: '#065F46', border: '#10B981' },
  'Vegan':           { icon: 'sprout',  bg: '#F0FDF4', color: '#166534', border: '#22C55E' },
  'Iconic':          { icon: 'crown',   bg: '#EFF6FF', color: '#1E40AF', border: '#60A5FA' },
  "Chef's Special":  { icon: 'chefhat', bg: '#ECFEFF', color: '#155E75', border: '#06B6D4' },
  'New':             { icon: 'sparkle', bg: '#FFF1F2', color: '#BE123C', border: '#FB7185' },
};

export interface ResolvedTag {
  Icon: React.FC<{ size?: number }> | null;
  label: string;
  bg: string;
  color: string;
  border: string;
}

export function resolveTag(tag: string): ResolvedTag {
  const bare = stripTagEmoji(tag);
  const normalized = bare.replace(/[''\u02BC]/g, "'");
  const style = TAG_STYLES[normalized] || TAG_STYLES[bare];
  if (style) {
    const Icon = style.icon ? TAG_ICON_MAP[style.icon] : null;
    return { Icon, label: normalized, bg: style.bg, color: style.color, border: style.border };
  }
  return { Icon: null, label: bare || tag, bg: '#FFFBEB', color: '#92400E', border: '#F59E0B' };
}
